import { isLuxPlusSubscriptionItem, isSubscriptionJoinItem } from 'lib/checkout/checkoutUtils'
import { getCanRedeemLuxPlusBenefitsOnOrder } from 'luxPlus/selectors/featureToggle'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

/**
 * Leaf item selectors for LuxPlus cart membership.
 * Kept free of payment/view barrel imports so payment selectors can consume them
 * without forming cycles through luxPlusSubscription.ts.
 */
export const getLuxPlusSubscriptionItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.LuxPlusSubscriptionItem> => items.filter(isLuxPlusSubscriptionItem),
  reselectShallowEqual,
)

export const getSubscriptionJoinItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => items.filter(isSubscriptionJoinItem),
)

export const isStandaloneLuxPlusSubscription = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => !!items.length && items.every(item => isLuxPlusSubscriptionItem(item) || isSubscriptionJoinItem(item)),
)

export const isLuxPlusSubscriptionInCart = createSelector(
  (state: App.State) => getLuxPlusSubscriptionItems(state),
  (items): boolean => items.length > 0,
)

export const getHasLuxPlusOrSubscriptionInCart = createSelector(
  (state: App.State) => isLuxPlusSubscriptionInCart(state),
  (state: App.State) => getCanRedeemLuxPlusBenefitsOnOrder(state),
  (isLuxPlusSubscriptionInCart, canRedeemOnOrder): boolean =>
    !!(isLuxPlusSubscriptionInCart || canRedeemOnOrder),
)
